// mills
export const MILL_PROGRESS = "MILL_PROGRESS";
export const MILL_MAP_PROGRESS = "MILL_MAP_PROGRESS";
export const GET_MILLS = "GET_MILLS";
export const SELECT_MILL = "SELECT_MILL";
export const SET_FILTER = "SET_FILTER";
export const IS_PDF = "IS_PDF";
export const IS_IN_EXTENT = "IS_IN_EXTENT";

// messages
export const GET_ERRORS = "GET_ERRORS";
export const GET_SUCCESS = "GET_SUCCESS";
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";

// settings
export const TOUR_OPEN = "TOUR_OPEN";
export const FILTER_OPEN = "FILTER_OPEN";
export const PROMPT = "PROMPT";
export const SET_COORDINATES = "SET_COORDINATES";
export const SET_ZOOM = "SET_ZOOM";
export const SET_INFO = "SET_INFO";
export const SET_CAROUSEL = "SET_CAROUSEL";
